/* eslint-disable no-restricted-syntax */

import React, { useState, useEffect } from 'react';
import i18n from 'i18n-react';

import PropTypes from 'prop-types';

import { baseAppId, storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { APIHandler, DataHandler, StorageHandler } from 'C4';

const names = {
  facebook: 'fb',
  twitter: 'twitter',
  mail: 'email',
  download: 'download',
};

const copyFunction = (str) => {
  const area = document.createElement('textarea');
  area.value = str;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.left = '-1000rem';
  document.body.appendChild(area);
  area.focus();
  area.select();
  document.execCommand('copy');
  document.body.removeChild(area);
};

const SharingPopup = (props) => {
  const {
    url, triggerId, title, image,
    twitterShare,
    shareTitle,
    shareContent,
    videoEmailCopy,
    videoEmailSubject,
    imageEmailCopy,
    imageEmailSubject,
    backgroundImage,
  } = props;

  let internalURL = url.length > 0 ? url.match(/[0-9]{3}.*?$/g) : '';
  if (url.includes('jwplatform')) {
    internalURL = url;
  }

  if (url.includes('travproconnect')) {
    internalURL = url;
  }
  const parsedURL = `https://academyshare.travpromobile.com/?file=${internalURL}`;

  // Creates a download url based on app_id, if above 499 use the new developer tool
  let downloadUrl = `https://cdn.travpromobile.com/apptool/app/${internalURL}`;
  if (internalURL && internalURL.toString().split('/')[0] > 499) {
    downloadUrl = `https://front.travpromobile.com/${internalURL}`;
  }

  if (url.includes('jwplatform')) {
    downloadUrl = url;
  }

  let thumbnail = image;
  if (!image.includes('http')) {
    thumbnail = `https://front.travpromobile.com/${baseAppId}/${image}`;
  }
  let urlEncoded = url.length > 0 ? parsedURL.replace(/ /g, '%20') : '';
  urlEncoded = urlEncoded.replace('https://', 'https://');
  urlEncoded = urlEncoded.replace('http://', 'http://');
  urlEncoded = urlEncoded.replace('travprocdn', 'travprocdn');

  if (url.includes('travproconnect')) {
    urlEncoded = url;
    thumbnail = backgroundImage;
  }

  urlEncoded = `${urlEncoded}&subject=${title}`;
  urlEncoded = `${urlEncoded}&image=${backgroundImage}`;

  // Image // Infographic (pdf or png) // Video
  const extension = url.substring(url.lastIndexOf('.') + 1);
  let shareSubject = shareTitle;
  let shareCopy = shareContent;
  if (extension === 'png' || extension === 'jpg') {
    shareSubject = imageEmailSubject;
    shareCopy = imageEmailCopy;
  } else if (extension === 'mp4') {
    shareSubject = videoEmailSubject;
    shareCopy = videoEmailCopy;
  } else if (url.includes('travproconnect')) {
    shareSubject = shareTitle;
    shareCopy = shareContent;
  }

  const hide = { display: triggerId ? 'none' : 'inline-block' };

  const onClickEvent = async (button) => {
    const appId = await DataHandler.matchAppId();
    const { email } = await StorageHandler.load('user');
    const name = names[button.querySelector('span').innerHTML.toLowerCase()];
    await APIHandler.trackEvent(
      appId,
      email,
      name === 'download' ? 'downloads' : 'shares',
      name,
      button.href,
    );
  };

  if (!window.observers) window.observers = {};

  if (!window.observers[url]) {
    window.observers[url] = new MutationObserver(async (list, observer) => {
      for (const mutation of list) {
        if (mutation.target.querySelector('.fancybox-share')) {
          const element = document.querySelector('.fancybox-share');
          const input = element.querySelector('#shareURL');

          if (input) {
            input.onclick = async ({ target }) => {
              /* eslint-disable no-param-reassign */
              target.innerText = i18n.translate('sharing.copied');
              copyFunction(target.value);
              setTimeout(() => {
                target.innerText = i18n.translate('sharing.copyURL');
              }, 2000);
              /* eslint-enable no-param-reassign */
            };
          }

          const wrapperParagraph = document.querySelector('.wrapper__paragraph');
          let wrapper = {};
          if (wrapperParagraph && wrapperParagraph.children) {
            wrapper = wrapperParagraph.children;
          }
          Array.from(wrapper).forEach((button, i) => { wrapper[i].onclick = () => onClickEvent(button); });

          observer.disconnect();
          window.observers[url] = null;
        }
      }
    });
    window.observers[url].observe(document.body, { childList: true });
  }

  return (
    <div className="fancybox-share" id={triggerId || null} style={hide}>
      <h3>{i18n.translate('share.header')}</h3>
      <p className="wrapper__paragraph">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${urlEncoded}`}
          className="fancybox-share__button fancybox-share__button--fb"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" />
          </svg>
          <span>Facebook</span>
        </a>
        <a
          href={`https://twitter.com/share?url=${urlEncoded}&text=${shareSubject}`}
          className="fancybox-share__button fancybox-share__button--tw"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x-twitter" class="svg-inline--fa fa-x-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
          <span>Twitter</span>
        </a>
        <a
          href={`mailto:?subject=${shareSubject}&body=${shareCopy} ${urlEncoded}`}
          className="fancybox-share__button fancybox-share__button--pt"
        >
          <FontAwesomeIcon icon={['far', 'at']} />
          <span>Mail</span>
        </a>
        {!url.includes('travproconnect') && <a
          href={`https://stack.travpromobile.com/download.php?url=${downloadUrl}`}
          className="fancybox-download__button fancybox-download__button--pt"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={['far', 'download']} />
          <span>{i18n.translate('share.download')}</span>
        </a>}
      </p>
      <p>
        <button
          id="shareURL"
          className="fancybox-share__input"
          type="button"
          value={urlEncoded}
        >
          {i18n.translate('sharing.copyURL')}
        </button>
      </p>
    </div>
  );
};

export default SharingPopup;

SharingPopup.propTypes = {
  url: PropTypes.string.isRequired,
  triggerId: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  twitterShare: PropTypes.string,
  shareTitle: PropTypes.string,
  shareContent: PropTypes.string,
  videoEmailCopy: PropTypes.string,
  videoEmailSubject: PropTypes.string,
  imageEmailCopy: PropTypes.string,
  imageEmailSubject: PropTypes.string,
  backgroundImage: PropTypes.string,
};

SharingPopup.defaultProps = {
  triggerId: '',
  image: '',
  title: '',
  twitterShare: '',
  shareTitle: '',
  shareContent: '',
  videoEmailCopy: '',
  videoEmailSubject: '',
  imageEmailCopy: '',
  imageEmailSubject: '',
  backgroundImage: '',
};
